import auth from "../../middlewares/auth";
export const settingsParkingsRoute = [
  {
    path: '/settings/parkings',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/parking/ParkingList'),
    name: 'settings_parkings',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/parkings/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/parking/ParkingForm'),
    name: 'settings_parking_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/parkings/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/parking/ParkingForm'),
    name: 'settings_parking_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];